import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const TYPE_COLORS = {
  character: "text-amber-300",
  npc: "text-emerald-300",
  creature: "text-rose-300",
  location: "text-sky-300",
  lore: "text-violet-300",
  deity: "text-yellow-300",
  item: "text-orange-300",
};

const MentionList = forwardRef(({ items, command, loading }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => setSelectedIndex(0), [items]);

  const selectItem = (index) => {
    const item = items[index];
    if (item) {
      command({
        id: `${item.type}:${item.id}`,
        label: item.name,
        href: item.href,
      });
    }
  };

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === "ArrowUp") {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        setSelectedIndex((selectedIndex + 1) % items.length);
        return true;
      }
      if (event.key === "Enter" || event.key === "Tab") {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  return (
    <div
      className="bg-card border border-border rounded-sm shadow-xl py-1 min-w-[240px] max-w-[320px] max-h-[280px] overflow-y-auto"
      data-testid="mention-suggestion-list"
    >
      {loading && (
        <div className="px-3 py-2 text-xs text-muted-foreground">Searching…</div>
      )}
      {!loading && items.length === 0 && (
        <div className="px-3 py-2 text-xs text-muted-foreground">No matches — keep typing</div>
      )}
      {items.map((item, index) => (
        <button
          key={`${item.type}-${item.id}`}
          type="button"
          className={`w-full text-left px-3 py-1.5 flex items-center gap-2 text-sm ${
            index === selectedIndex ? "bg-muted/60" : "hover:bg-muted/40"
          }`}
          onClick={() => selectItem(index)}
          data-testid={`mention-result-${item.id}`}
        >
          <span
            className={`text-[9px] uppercase tracking-wider font-semibold ${
              TYPE_COLORS[item.type] || "text-muted-foreground"
            }`}
          >
            {item.type}
          </span>
          <span className="text-foreground truncate">{item.name}</span>
        </button>
      ))}
    </div>
  );
});

MentionList.displayName = "MentionList";

export default MentionList;
